import { memo, useMemo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './ListParameter.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { Parameter } from '@Pages/PageProduct/typings';

export interface ListParameterProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  parameter: Parameter;
}

const ListParameter: FC<ListParameterProps> = (props) => {
  const { className, parameter, ...restProps } = props;

  const value = useMemo(() => {
    return parameter.variants.map((variant) => variant.name.toLocaleLowerCase()).join(', ');
  }, [parameter.variants]);

  return (
    <div {...restProps} className={cn(styles.parameter, className)}>
      <span className={styles.name}>{`${parameter.name}: `}</span>
      <span>{value}</span>
    </div>
  );
};

export default memo(ListParameter);
